import { CategoriesOrder } from './categories-order';
import { Category } from './category';
import { CategoryWithRatings } from './category-with-ratings';
import { RatingSentence } from './rating-sentence';

export class CategoriesWithRatingsByYearSegment {
  wholeYear: CategoryWithRatings[] = [];
  firstHalf: CategoryWithRatings[] = [];
  secondHalf: CategoryWithRatings[] = [];

  constructor(
    categories: Category[] = [],
    categoriesOrder: CategoriesOrder = {
      categoryIdsWholeYear: [],
      categoryIdsFirstHalf: [],
      categoryIdsSecondHalf: [],
    },
    ratings: RatingSentence[] = []
  ) {
    this.initializeCategories(categories, categoriesOrder, ratings);
  }

  private initializeCategories(
    categories: Category[],
    categoriesOrder: CategoriesOrder,
    ratings: RatingSentence[]
  ): void {
    this.wholeYear = this.mapCategories(
      categories,
      categoriesOrder.categoryIdsWholeYear,
      ratings
    );
    this.firstHalf = this.mapCategories(
      categories,
      categoriesOrder.categoryIdsFirstHalf,
      ratings
    );
    this.secondHalf = this.mapCategories(
      categories,
      categoriesOrder.categoryIdsSecondHalf,
      ratings
    );
  }

  private mapCategories(
    categories: Category[],
    categoryIds: string[],
    ratings: RatingSentence[]
  ): CategoryWithRatings[] {
    return categories
      .filter((category) => categoryIds.includes(category.id!.toString()))
      .map((category) => ({
        category,
        ratings: filterRatingsByCategory(ratings, category.id!.toString()),
      }));
  }

  flattenCategories(): CategoryWithRatings[] {
    return [...this.wholeYear, ...this.firstHalf, ...this.secondHalf];
  }

  categoriesLength(): number {
    return (
      this.wholeYear.length + this.firstHalf.length + this.secondHalf.length
    );
  }
}

const filterRatingsByCategory = (
  ratings: RatingSentence[],
  categoryId: string
) => ratings.filter((rating) => rating.categoryId === categoryId);
